/*
 * Copyright (c) Outright Mental (https://outrightmental.com/) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./DashMessage.scss"
import {
  PLAYER_MESSAGE_TYPE_EXPENSE,
  PLAYER_MESSAGE_TYPE_INFO,
  PLAYER_MESSAGE_TYPE_MARKET,
  PLAYER_MESSAGE_TYPE_PAYROLL
} from "../../constants";
import theme from "../../theme";

/**
 * Return the background color for a given message type
 * @param {{type,content}} message of message to get background color for
 * @returns {string} background color for message
 */
function backgroundColorFor(message) {
  switch (message.type) {

    case PLAYER_MESSAGE_TYPE_EXPENSE:
      return theme.pinkLow;

    case PLAYER_MESSAGE_TYPE_PAYROLL:
      return theme.purpleLow;

    case PLAYER_MESSAGE_TYPE_MARKET:
      return theme.greenLow;

    case PLAYER_MESSAGE_TYPE_INFO:
    default:
      return theme.grayHigh;
  }
}

/**
 DashMessage component renders the given message in specified style and adornment.
 <p>
 @return {*}
 @param {{
  message:{type,content}
 }} props for this component
 */
export default function DashMessage(props) {
  const
    message = props.message,
    backgroundColor = backgroundColorFor(message);

  return (
    <div className="dash-message" style={{backgroundColor}}>
      {message.content}
    </div>
  );
};
